import { InferType, q } from "groqd";

import { runQuery } from "../../../lib/sanityClient";

const pathShape = q("*")
    .filterByType("article")
    .filter("hidden != true")
    .filter('!(_id in path("drafts.**"))')
    .grab({
        slug: [
            "slug",
            q.object({
                current: q.string(),
                _type: q.literal("slug")
            })
        ],
        language: [
            "coalesce(language, 'en')",
            q.union([q.literal("en"), q.literal("fr")])
        ]
    });

export type PostPaths = InferType<typeof pathShape>;

export const getPostPaths = async () =>
    runQuery(pathShape).then((data) => pathShape.schema.parse(data));
